 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER901SEETHESUNAGAIN from '@/components/0_chapter901seethesunagain'
 import A_CHAPTER902PERSISTENTDISEASE from '@/components/1_chapter902persistentdisease'
 import A_CHAPTER903CURES from '@/components/2_chapter903cures'
 import A_CHAPTER904RETURN from '@/components/3_chapter904return'
 import A_CHAPTER905COUNTERATTACK from '@/components/4_chapter905counterattack'
 import A_CHAPTER906SCHEDULE from '@/components/5_chapter906schedule'
 import A_CHAPTER907CLUESTOTHEBALD from '@/components/6_chapter907cluestothebald'
 import A_CHAPTER908BEIJINGTOMEETANOLDFRIEND from '@/components/7_chapter908beijingtomeetanoldfriend'
 import A_CHAPTER909JIANGCHENGSIDENTITY from '@/components/8_chapter909jiangchengsidentity'
 import A_CHAPTER910BULLETSINTHECHEST from '@/components/9_chapter910bulletsinthechest'
 import A0_CHAPTER911SUNBINSEXPERIENCE from '@/components/10_chapter911sunbinsexperience'
 import A1_CHAPTER912SUNBINSDEATH from '@/components/11_chapter912sunbinsdeath'
 import A2_CHAPTER913EMPTYROOM from '@/components/12_chapter913emptyroom'
 import A3_CHAPTER914ZHENGGUANG from '@/components/13_chapter914zhengguang'
 import A4_CHAPTER915TRUTH from '@/components/14_chapter915truth'
 import A5_CHAPTER916THEYWANTEDTOCAPTUREHIMBUTTHEYDIDNTDOSO from '@/components/15_chapter916theywantedtocapturehimbuttheydidntdoso'
 import A6_CHAPTER917SHEDDINGOFCICADA from '@/components/16_chapter917sheddingofcicada'
 import A7_CHAPTER918FACTORYEXPLORATION from '@/components/17_chapter918factoryexploration'
 import A8_CHAPTER919ENEMYOFTHEENEMY from '@/components/18_chapter919enemyoftheenemy'
 import A9_CHAPTER920RAISETHECLOUDSANDSEETHESUN from '@/components/19_chapter920raisethecloudsandseethesun'
 import A0_CHAPTER921GHOST from '@/components/20_chapter921ghost'
 import A1_CHAPTER922RECOGNITION from '@/components/21_chapter922recognition'
 import A2_CHAPTER923MAUSENGROUP from '@/components/22_chapter923mausengroup'
 import A3_CHAPTER924SCHEDULE from '@/components/23_chapter924schedule'
 import A4_CHAPTER925SUSPICION from '@/components/24_chapter925suspicion'
 import A5_CHAPTER926ARMS from '@/components/25_chapter926arms'
 import A6_CHAPTER927MANTISANDCICADA from '@/components/26_chapter927mantisandcicada'
 import A7_CHAPTER928ENCOUNTER from '@/components/27_chapter928encounter'
 import A8_CHAPTER929BATTLEATTHEDOCKS from '@/components/28_chapter929battleatthedocks'
 import A9_CHAPTER930CAPTIVE from '@/components/29_chapter930captive'
 import A0_CHAPTER931CUES from '@/components/30_chapter931cues'
 import A1_CHAPTER932BAMBOOGARDEN from '@/components/31_chapter932bamboogarden'
 import A2_CHAPTER933WARLORD from '@/components/32_chapter933warlord'
 import A3_CHAPTER934LIMAOSEN from '@/components/33_chapter934limaosen'
 import A4_CHAPTER935TERRIFYINGPOWER from '@/components/34_chapter935terrifyingpower'
 import A5_CHAPTER936EVIDENCE from '@/components/35_chapter936evidence'
 import A6_CHAPTER937UNFORESEEN from '@/components/36_chapter937unforeseen'
 import A7_CHAPTER938DISCOVERY from '@/components/37_chapter938discovery'
 import A8_CHAPTER939RESCUE from '@/components/38_chapter939rescue'
 import A9_CHAPTER940REGRESSION from '@/components/39_chapter940regression'
 import A0_CHAPTER941FAREWELLJIANGCHENG from '@/components/40_chapter941farewelljiangcheng'
 import A1_CHAPTER942START from '@/components/41_chapter942start'
 import A2_CHAPTER943DANGER from '@/components/42_chapter943danger'
 import A3_CHAPTER944ENCOUNTER from '@/components/43_chapter944encounter'
 import A4_CHAPTER945GOAL from '@/components/44_chapter945goal'
 import A5_CHAPTER946ESCAPE from '@/components/45_chapter946escape'
 import A6_CHAPTER947UNFORESEEN from '@/components/46_chapter947unforeseen'
 import A7_CHAPTER948HELP from '@/components/47_chapter948help'
 import A8_CHAPTER949FIDUCIARY from '@/components/48_chapter949fiduciary'
 import A9_CHAPTER950CHESSCHESS from '@/components/49_chapter950chesschess'
 import A0_CHAPTER951FAIL from '@/components/50_chapter951fail'
 import A1_CHAPTER952REGRESSION from '@/components/51_chapter952regression'
 import A2_CHAPTER953REMINISCENTOFTHEPAST from '@/components/52_chapter953reminiscentofthepast'
 import A3_CHAPTER954FACELESSPERSON from '@/components/53_chapter954facelessperson'
 import A4_CHAPTER955SUDDENAPPEARANCE from '@/components/54_chapter955suddenappearance'
 import A5_CHAPTER956CYPRESSORCHARD from '@/components/55_chapter956cypressorchard'
 import A6_CHAPTER957LONGQIUYUESPROGRESS from '@/components/56_chapter957longqiuyuesprogress'
 import A7_CHAPTER958DRAGONCROSSINGRIVER from '@/components/57_chapter958dragoncrossingriver'
 import A8_CHAPTER959BREAKOUT from '@/components/58_chapter959breakout'
 import A9_CHAPTER960ONTHEEVEOFTHEFINALBATTLE from '@/components/59_chapter960ontheeveofthefinalbattle'
 import A0_CHAPTER961CROSS from '@/components/60_chapter961cross'
 import A1_CHAPTER962AQINGANDAHONG from '@/components/61_chapter962aqingandahong'
 import A2_CHAPTER963LUNARECLIPSE from '@/components/62_chapter963lunareclipse'
 import A3_CHAPTER964THEGIANTDRAGONGOESOUTOFTHEVALLEY from '@/components/63_chapter964thegiantdragongoesoutofthevalley'
 import A4_CHAPTER965STRIKE from '@/components/64_chapter965strike'
 import A5_CHAPTER966LAST from '@/components/65_chapter966last'
 import A6_CHAPTER967DECISIVEBATTLE from '@/components/66_chapter967decisivebattle'
 import A7_CHAPTER968DESTRUCTION from '@/components/67_chapter968destruction'
 import A8_CHAPTER969FOLLOWUP from '@/components/68_chapter969followup'
 import A9_CHAPTER970STRANGEINJURY from '@/components/69_chapter970strangeinjury'
 import A0_CHAPTER971END from '@/components/70_chapter971end'
 import A1_CHAPTER972CUES from '@/components/71_chapter972cues'
 import A2_CHAPTER973CLOUDSEARCHINGSTATE from '@/components/72_chapter973cloudsearchingstate'
 import A3_CHAPTER974SCHEDULE from '@/components/73_chapter974schedule'
 import A4_CHAPTER975CHALLENGE from '@/components/74_chapter975challenge'
 import A5_CHAPTER976LESSONS from '@/components/75_chapter976lessons'
 import A6_CHAPTER977GIANTSTAR from '@/components/76_chapter977giantstar'
 import A7_CHAPTER978TROUBLE from '@/components/77_chapter978trouble'
 import A8_CHAPTER979RELATIONSHIP from '@/components/78_chapter979relationship'
 import A9_CHAPTER980READY from '@/components/79_chapter980ready'
 import A0_CHAPTER981DEPARTURE from '@/components/80_chapter981departure'
 import A1_CHAPTER982SEPARATE from '@/components/81_chapter982separate'
 import A2_CHAPTER983SHROUYUSHAN from '@/components/82_chapter983shrouyushan'
 import A3_CHAPTER984CUSHIE from '@/components/83_chapter984cushie'
 import A4_CHAPTER985KUSSISHOME from '@/components/84_chapter985kussishome'
 import A5_CHAPTER986SETTLE from '@/components/85_chapter986settle'
 import A6_CHAPTER987RETURNOFKUSSI from '@/components/86_chapter987returnofkussi'
 import A7_CHAPTER988TREATMENT from '@/components/87_chapter988treatment'
 import A8_CHAPTER989OPENCLINIC from '@/components/88_chapter989openclinic'
 import A9_CHAPTER990WAKEUP from '@/components/89_chapter990wakeup'
 import A0_CHAPTER991ENJOY from '@/components/90_chapter991enjoy'
 import A1_CHAPTER992DEPARTURE from '@/components/91_chapter992departure'
 import A2_CHAPTER993MOUNTAINENTERING from '@/components/92_chapter993mountainentering'
 import A3_CHAPTER994FIGHTING from '@/components/93_chapter994fighting'
 import A4_CHAPTER995DEATH from '@/components/94_chapter995death'
 import A5_CHAPTER996TRACING from '@/components/95_chapter996tracing'
 import A6_CHAPTER997STRANGELAKE from '@/components/96_chapter997strangelake'
 import A7_CHAPTER998DOUBT from '@/components/97_chapter998doubt'
 import A8_CHAPTER999RESCUE from '@/components/98_chapter999rescue'
 import A9_CHAPTER1000STRENGTH from '@/components/99_chapter1000strength'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter901seethesunagain",
 			"name" : "0_chapter901seethesunagain",
 			"component" : A_CHAPTER901SEETHESUNAGAIN
 		},
 		{
 			"path" : "/1_chapter902persistentdisease",
 			"name" : "1_chapter902persistentdisease",
 			"component" : A_CHAPTER902PERSISTENTDISEASE
 		},
 		{
 			"path" : "/2_chapter903cures",
 			"name" : "2_chapter903cures",
 			"component" : A_CHAPTER903CURES
 		},
 		{
 			"path" : "/3_chapter904return",
 			"name" : "3_chapter904return",
 			"component" : A_CHAPTER904RETURN
 		},
 		{
 			"path" : "/4_chapter905counterattack",
 			"name" : "4_chapter905counterattack",
 			"component" : A_CHAPTER905COUNTERATTACK
 		},
 		{
 			"path" : "/5_chapter906schedule",
 			"name" : "5_chapter906schedule",
 			"component" : A_CHAPTER906SCHEDULE
 		},
 		{
 			"path" : "/6_chapter907cluestothebald",
 			"name" : "6_chapter907cluestothebald",
 			"component" : A_CHAPTER907CLUESTOTHEBALD
 		},
 		{
 			"path" : "/7_chapter908beijingtomeetanoldfriend",
 			"name" : "7_chapter908beijingtomeetanoldfriend",
 			"component" : A_CHAPTER908BEIJINGTOMEETANOLDFRIEND
 		},
 		{
 			"path" : "/8_chapter909jiangchengsidentity",
 			"name" : "8_chapter909jiangchengsidentity",
 			"component" : A_CHAPTER909JIANGCHENGSIDENTITY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js